var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.729614,
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.26086,
    y: 0.53125,
    width: 32.9375,
    height: 32.9375,
    rx: 16.4688,
    stroke: "#005DA8",
    strokeOpacity: 0.2,
    strokeWidth: 1.0625
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.813 20.4844V22.6094C24.8138 22.8067 24.7734 23.002 24.6944 23.1827C24.6153 23.3635 24.4994 23.5257 24.3541 23.6591C24.2087 23.7924 24.0371 23.894 23.8502 23.9572C23.6633 24.0204 23.4653 24.0438 23.2688 24.0261C21.0892 23.7892 18.9955 23.0444 17.1559 21.8515C15.4445 20.764 13.9934 19.313 12.9059 17.6015C11.7088 15.7536 10.9638 13.6497 10.7313 11.4603C10.7136 11.2644 10.7369 11.067 10.7997 10.8806C10.8625 10.6942 10.9634 10.5229 11.096 10.3776C11.2286 10.2324 11.3899 10.1163 11.5699 10.0369C11.7498 9.9574 11.9442 9.91627 12.1409 9.91608H14.2659C14.6097 9.9127 14.9429 10.0344 15.2036 10.2586C15.4642 10.4827 15.6345 10.794 15.6826 11.1344C15.7723 11.8145 15.9386 12.4822 16.1784 13.1248C16.2737 13.3784 16.2943 13.6539 16.2379 13.9188C16.1814 14.1837 16.0501 14.4268 15.8597 14.6194L14.9601 15.519C15.9684 17.2923 17.4367 18.7606 19.2101 19.769L20.1097 18.8694C20.3023 18.679 20.5454 18.5477 20.8103 18.4912C21.0752 18.4347 21.3507 18.4554 21.6043 18.5507C22.2469 18.7905 22.9146 18.9568 23.5947 19.0465C23.9388 19.095 24.253 19.2684 24.4776 19.5335C24.7023 19.7986 24.8216 20.137 24.813 20.4844Z",
    stroke: "#005DA8",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/Audio.56ba18db7ca42701a494dadc24839655.svg";
export { ForwardRef as ReactComponent };